import { api } from '../AppConfig';

import { connect, catch401s } from './utils';

const getSeason = (resolve, reject, id) => () => {
    return {
      season: {
        url: api.seasons().detailsById(id).href,
        then: resolve,
        catch: reject,
        refreshing: true,
        force: true,
      }
    }
  }

const ajaxSeason = connect(({id}) => ({
    season: {
        url: api.seasons().detailsById(id).href,
        andThen: season => { return { stages: api.seasons().getStages(id).href, ranking: api.seasons().getRanking(id).href, metagame: api.seasons().getMetagame(id).href}},
        catch: catch401s,
    },
}));

export default ajaxSeason;